import { initializePendo } from '@investigator/shared/utils';
import { ReactNode, useContext, useEffect, useState } from 'react';

import { AuthContext } from '../AuthProvider';
import { CookieContext, CookieContextProps } from './CookieContext';

interface CookieProviderProps {
  children?: ReactNode;
}

export const CookieProvider = ({ children }: CookieProviderProps) => {
  const { user, userLicense } = useContext(AuthContext);

  const [cookieConfig, setCookieConfig] = useState<CookieContextProps>({
    isOpen: false,
    initialStep: 1,
    getUserCookieAcceptance: [],
  });

  useEffect(() => {
    if (!user) return;
    if (!userLicense) return;
    const pendoParams = {
      user,
      userLicense,
      isCookieAccepted: cookieConfig?.getUserCookieAcceptance?.find(
        (cookie) => cookie?.cookie_type === 'ANALYTICS',
      )?.cookies_accepted,
    };
    initializePendo(pendoParams);
  }, [user, userLicense, cookieConfig]);

  return (
    <CookieContext.Provider
      value={{
        ...cookieConfig,
        setCookieConfig,
      }}
    >
      {children}
    </CookieContext.Provider>
  );
};
